import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show banner after a short delay
      setTimeout(() => {
        setShowBanner(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6"
        >
          <div className="container mx-auto max-w-6xl">
            <div className="bg-white rounded-2xl shadow-2xl border border-olive-green/20 p-6 sm:p-8">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                {/* Icon */}
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-olive-green/10 rounded-full flex items-center justify-center">
                    <Cookie className="w-6 h-6 text-olive-green" />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <h3 className="text-lg sm:text-xl font-bold text-charcoal mb-2 font-heading">
                    Cookies & Datenschutz
                  </h3>
                  <p className="text-charcoal/80 text-sm sm:text-base leading-relaxed">
                    Wir verwenden ggf. notwendige Cookies, um die Funktionalität unserer Website zu gewährleisten. 
                    Wir setzen keine Tracking- oder Werbecookies ein. Weitere Informationen findest du in unserer{' '}
                    <Link to="/datenschutz" className="text-olive-green font-semibold hover:text-olive-dark underline">
                      Datenschutzerklärung
                    </Link>.
                  </p>
                </div>

                {/* Buttons */}
                <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
                  <button
                    onClick={handleAccept}
                    className="bg-olive-green hover:bg-olive-dark text-white px-6 py-3 rounded-lg font-bold text-sm transition-all transform hover:scale-105 shadow-lg whitespace-nowrap"
                  >
                    Akzeptieren
                  </button>
                  <button
                    onClick={handleDecline}
                    className="bg-gray-200 hover:bg-gray-300 text-charcoal px-6 py-3 rounded-lg font-bold text-sm transition-all whitespace-nowrap"
                  >
                    Ablehnen
                  </button>
                </div>

                {/* Close button for desktop */}
                <button
                  onClick={handleDecline}
                  className="hidden sm:block absolute top-4 right-4 text-charcoal/40 hover:text-charcoal transition-colors"
                  aria-label="Schließen"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
